import MenuItem from "../types/MenuItem";

export const MenuItemsParametrages: MenuItem[] = [
  {
    title: 'Pays',
    code: 'PAYS',
    path: '/pays',
    cName: 'dropdown-link'
  },
  {
    title: 'Business units',
    code: 'BU',
    path: '/business-units',
    cName: 'dropdown-link'
  },
  {
    title: 'Clients',
    code: 'CLT',
    path: '/clients',
    cName: 'dropdown-link'
  },
  {
    title: 'Opérations',
    code: 'OPERA',
    path: '/operations',
    cName: 'dropdown-link'
  },
  {
    title: 'Articles',
    code: 'ARTL',
    path: '/article',
    cName: 'dropdown-link'
  },
  {
    title: 'Tarifs',
    code: 'TRF',
    path: '/tarifs',
    cName: 'dropdown-link'
  },
  {
    title: 'Coûts',
    code: 'COUT',
    path: '/couts',
    cName: 'dropdown-link'
  },
  {
    title: 'Managers par opérations',
    code: 'MNGR_OPERA',
    path: '/Managers-operations',
    cName: 'dropdown-link'
  },
  {
    title: "Taux de Change",
    code: 'TAUX',
    path: '/taux',
    cName: 'dropdown-link'
  },
  {
    title: "Dates de verrouillage",
    code: 'DATE_VERR',
    path: '/date-verouillage',
    cName: 'dropdown-link'
  },
  {
    title: "Date de verrouillage et clôture Budget",
    code: 'DATE_VERR_CLO_BUDGET',
    path: '/date-verouillage-cloture-budget',
    cName: 'dropdown-link'
  },
  {
    title: "Date de verrouillage et clôture Reforecast",
    code: 'DATE_VERR_CLO_REFOR',
    path: '/date-verouillage-cloture-reforecast',
    cName: 'dropdown-link'
  },
  {
    title: "Secteurs d’Activités",
    code: 'SECT_ACT',
    path: '/secteur-act',
    cName: 'dropdown-link'
  },
  /*
  {
    title: 'Famille Opération',
    code: 'FML_OPERA',
    path: '/famille-operation',
    cName: 'dropdown-link'
  },
  {
    title: 'Pays de facturation',
    code: 'PAYS_FACT',
    path: '/pays-facturation',
    cName: 'dropdown-link'
  },
  {
    title: 'Société de facturation',
    code: 'SOC_FACT',
    path: '/societe-facturation',
    cName: 'dropdown-link'
  },
  */
  {
    title: 'Utilisateurs',
    code: 'USER',
    path: '/user',
    cName: 'dropdown-link'
  }
];

export const MenuItemsProduction: MenuItem[] = [
  {
    title: 'Saisie Manager',
    code: 'HOURS_AGENT',
    path: '/saisie-agent',
    cName: 'dropdown-link'
  }
];

export const MenuItemsPrevisionnel: MenuItem[] = [
  {
    title: 'Prévisionnel des quantités',
    code: 'PREV_QT',
    path: '/previsionnel-qt',
    cName: 'dropdown-link'
  }
];

export const MenuItemsBudget: MenuItem[] = [
  {
    title: 'Budget',
    code: 'BUDGET',
    path: '/budget-client',
    cName: 'dropdown-link'
  },
  {
    title: 'Extraction Budget',
    code: 'EXT_BUDGET',
    path: '/extraction-budget',
    cName: 'dropdown-link'
  },
  {
    title: 'import Budget',
    code: 'IMP_BUDGET',
    path: '/import-budget',
    cName: 'dropdown-link'
  }
];

export const MenuItemsReforecast: MenuItem[] = [
  {
    title: 'Reforecast',
    code: 'REFOR',
    path: '/reforecast',
    cName: 'dropdown-link'
  },
  {
    title: 'Extraction Reforecast',
    code: 'EXT_REFOR',
    path: '/extraction-reforecast',
    cName: 'dropdown-link'
  },
  {
    title: 'Extraction Consolidation Reforecast',
    code: 'EXT_CONSO_REFOR',
    path: '/extraction-consolidation-reforcast',
    cName: 'dropdown-link'
  }
];

export const MenuItemsExtraction: MenuItem[] = [
  {
    title: 'Saisie',
    code: 'EXT_SAISIE',
    path: '/extraction-saisie',
    cName: 'dropdown-link'
  },
  /* {
    title: 'Renta clients',
    code: 'RENTA_CLI',
    path: '/renta-client',
    cName: 'dropdown-link'
  },
  {
    title: 'Coûts de supervision',
    code: 'COUT_SUP',
    path: '/cout-supervision',
    cName: 'dropdown-link'
  },
  {
    title: 'Flash',
    code: 'FLASH',
    path: '/flash',
    cName: 'dropdown-link'
  },


  {
    title: 'Tableau SI',
    code: 'TAB_SI',
    path: '/tableau-si',
    cName: 'dropdown-link'
  },
  {
    title: 'Tableau SI Flash',
    code: 'TAB_SI_FLASH',
    path: '/tableau-si-flash',
    cName: 'dropdown-link'
  },
  {
    title: 'Historique Prévisonnnel',
    code: 'HISTO_PREV',
    path: '/historique-previsonnnel',
    cName: 'dropdown-link'
  },
  {
    title: 'Extraction Prévisonnnel',
    code: 'EXTRACT_PREV',
    path: '/extraction-prévisonnnel',
    cName: 'dropdown-link'
  }, */
  {
    title: 'Rentabilité',
    code: 'EXTRACT_FACT',
    path: '/rentabilite',
    cName: 'dropdown-link'
  }
];

export const MenuItemsFacturation: MenuItem[] = [
  {
    title: 'Tableau de bord',
    code: 'DASHBOARD_FACT',
    path: '/tableau-de-bord',
    cName: 'dropdown-link'
  }
  ,
  {
    title: 'Générer Facture',
    code: 'FACTURE',
    path: '/generate-facture',
    cName: 'dropdown-link'
  }
  ,
  {
    title: 'Facture Proforma',
    code: 'FACTUREPRO',
    path: '/facturepro',
    cName: 'dropdown-link'
  }
];

export const MenuItemsCommission: MenuItem[] = [
  {
    title: 'Commisson Commercial/GRC',
    code: 'Commerciaux/GRC',
    path: '/generate-facture',
    cName: 'dropdown-link'
  },
  {
    title: 'Extraction Commission Commerciaux',
    code: 'EXT_COMM',
    path: '/extraction-commission',
    cName: 'dropdown-link'
  }
];